// extracted by mini-css-extract-plugin
export default {"container":"DashboardStatsContainer_container__r9xVk"};